<template>
  <main>
    <div class="container">
      <div class="main-content-box">
        <div class="top-page-divider">
          <h3 class="page-title center">Privacy Policy</h3>
        </div>
        <p>Version 1.0</p>
        <p>Effective Date: March 2025</p>
        <hr>

        <p>
          Xalor (“Xalor,” “we,” “our,” “us”) values your privacy and is committed
          to protecting your personal information. This Privacy Policy explains what information we collect,
          how we use it, how long we keep it, and the rights you have regarding your data.
        </p>
        <p>
          By using our games, websites, and services (“Services”), you agree to the practices described in this Privacy Policy.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">1. Who Controls Your Data?</h5>
        <p>
          Xalor is the data controller responsible for your information.
          Data may be processed in the United States in order to deliver certain game and platform services.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">2. What Information We Collect</h5>
        <p>We may collect information in the following ways:</p>

        <p><b>a) Information You Provide</b></p>
        <p>
          This includes account registration details, communication through social features, purchase and payment details,
          customer support interactions, and any data you provide while using our Services.
        </p>

        <p><b>b) Information We Generate</b></p>
        <p>
          We gather data related to your gameplay, in-game activity, device details, and usage patterns when you
          access or install our Services.
        </p>

        <p><b>c) Information from Third Parties</b></p>
        <p>
          We may receive information from third parties you link (such as Twitch, YouTube, or Facebook),
          advertisers, payment providers, or public sources. For example, if you log in with Facebook,
          certain profile data may be shared with us.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">3. Why We Process Your Data</h5>
        <p>We use your information for purposes including:</p>

        <ul class="bulletpoints">
          <li><b>Gameplay & Features</b> – progress tracking, inventories, stats, social interactions, in-game currency.</li>
          <li><b>Service Improvements</b> – analytics, testing, development, bug fixing, and training.</li>
          <li><b>Customer Support</b> – resolving issues, responding to inquiries, and moderating content.</li>
          <li><b>Transactions</b> – processing store purchases, payments, invoices, and refunds.</li>
          <li><b>Social Interaction</b> – enabling chats, forums, and community features.</li>
          <li><b>Player Communications</b> – updates, surveys, promotions, contests, and targeted content.</li>
          <li><b>Fraud & Abuse Prevention</b> – detecting cheating, preventing account compromise, and enforcing penalties.</li>
          <li><b>Legal & Compliance</b> – investigations, dispute resolution, and meeting regulatory requirements.</li>
        </ul>

        <hr>
        <h5 class="mt-4 mb-4">4. Legal Bases for Processing</h5>
        <p>We rely on the following legal grounds to process your data:</p>

        <ul class="bulletpoints">
          <li><b>Contractual Necessity</b> – data required to provide you access to our games and Services (e.g., accounts, purchases, gameplay).</li>
          <li><b>Legitimate Interests</b> – data used for analytics, optimization, fraud prevention, and customer support,
            where it does not outweigh your privacy rights.</li>
          <li><b>Legal Obligations</b> – data processed to comply with applicable laws, litigation, and security requirements.</li>
        </ul>

        <hr>
        <h5 class="mt-4 mb-4">5. Data Sharing</h5>
        <p>We may share information in the following cases:</p>

        <ul class="bulletpoints">
          <li><b>With Service Providers & Partners</b> – vendors, payment processors, survey companies, and others assisting in delivering our Services.</li>
          <li><b>With Other Players or the Public</b> – when you participate in chats, forums, leaderboards, or community features.</li>
          <li><b>With Subsidiaries & Affiliates</b> – to operate and support our Services across regions.</li>
          <li><b>For Legal Reasons</b> – when required by law, regulation, or to protect rights, safety, and property.</li>
        </ul>

        <hr>
        <h5 class="mt-4 mb-4">6. Tracking Technologies</h5>
        <p>
          We and our partners use cookies, beacons, scripts, and local storage (e.g., HTML5 or Flash cookies)
          to operate our websites, remember your settings, authenticate users, and deliver relevant ads.
          You may control cookies through your browser, but disabling them may limit certain features.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">7. Data Security</h5>
        <p>
          We use physical, technical, and administrative safeguards to protect your personal information.
          This includes regular testing, encryption, and restricted access. Third parties who process your data
          are also required to maintain adequate protections.
        </p>

        <hr>
        <h5 class="mt-4 mb-4">8. Data Retention</h5>
        <p>
          We retain personal data only as long as necessary to provide Services or as required by law.
          When no longer needed, data is securely deleted or anonymized.
        </p>
      </div>
    </div>
  </main>
</template>

<script>
export default {
  created() {
    document.title = 'Privacy Policy - Xalor'
  }
}
</script>
